import { render, staticRenderFns } from "./PartnersCenter.vue?vue&type=template&id=b358c5ba&scoped=true&"
import script from "./PartnersCenter.vue?vue&type=script&lang=js&"
export * from "./PartnersCenter.vue?vue&type=script&lang=js&"
import style0 from "./PartnersCenter.vue?vue&type=style&index=0&id=b358c5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b358c5ba",
  null
  
)

export default component.exports